/**
 * nebulaArtifactTypes.js
 *
 * Single source of truth for per-type capabilities used by NebulaCanvas
 * and NebulaCanvasControls.
 *
 *   hasTabs        — show Preview/Code segmented tab in Nebula header
 *   canDiff        — show diff button in Nebula header
 *   isHeavy        — preview needs explicit Run (don't auto-apply every keystroke)
 *   selfContained  — component manages its own controls; no Nebula header rendered
 *   downloadExt    — file extension used when downloading the artifact
 */
export const ARTIFACT_CAPS = {
  html:    { hasTabs: true,  canDiff: true,  isHeavy: true,  selfContained: false, downloadExt: "html" },
  react:   { hasTabs: true,  canDiff: false, isHeavy: true,  selfContained: true,  downloadExt: "jsx"  },
  plotly:  { hasTabs: true,  canDiff: false, isHeavy: false, selfContained: true,  downloadExt: "png"  },
  mermaid: { hasTabs: true,  canDiff: false, isHeavy: false, selfContained: true,  downloadExt: "svg"  },
  markmap: { hasTabs: true,  canDiff: false, isHeavy: false, selfContained: true,  downloadExt: "png"  },
  image:   { hasTabs: false, canDiff: false, isHeavy: false, selfContained: false, downloadExt: "png"  },
  video:   { hasTabs: false, canDiff: false, isHeavy: false, selfContained: false, downloadExt: "mp4"  },
  audio:   { hasTabs: false, canDiff: false, isHeavy: false, selfContained: false, downloadExt: "mp3"  },
  text:    { hasTabs: true,  canDiff: true,  isHeavy: false, selfContained: false, downloadExt: "md"   },
};

/** Returns caps for a type, falling back to text defaults if unknown. */
export const getCaps = (type) => ARTIFACT_CAPS[type] ?? ARTIFACT_CAPS.text;

/**
 * Maps each Photon custom fence name to the equivalent CodeMirror language
 * name for syntax highlighting inside markdown fenced code blocks.
 * Add entries here when new artifact fence types are introduced.
 */
export const PHOTON_FENCE_ALIASES = {
  "react-viz":   "javascript",
  "jsx-live":    "javascript",
  "physics-viz": "json",
  "json-viz":    "json",
  "mermaid":     "javascript",
  "markmap":     "markdown",
};
